<template>
  <div>
    <b-carousel
      id="carousel1"
      style="text-shadow: 1px 1px 2px #333;"
      controls
      indicators
      background="#ababab"
      :interval="4000"
      img-width="1024"
      img-height="300"
      v-model="slide"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <!-- Text slides with image -->
      <b-carousel-slide
        class="top-slider"
        v-for="item in items"
        :key="item.id"
        :style="
          'background-size: cover; background-repeat: no-repeat; background-position: center center; background-image: url(/images/slide/crop0/' +
            item.slideimg +
            ');'
        "
      >
        <b-link :to="item.id | view">
          <p>#{{ item.menu.name }}</p>
          <h3>{{ item.name }}</h3>
        </b-link>
      </b-carousel-slide>
    </b-carousel>
    <b-container class="mt-4" style="padding-left:0; padding-right:0;">
      <List :api="myApi" :preitems="preitems" />
    </b-container>
  </div>
</template>

<script>
import List from "./global/List";
import { getList, getHome } from "./../api";

export default {
  components: {
    List
  },
  data() {
    return {
      slide: 0,
      sliding: null,
      myApi: getList,
      items: [],
      preitems: [],
      loading: true
    };
  },
  methods: {
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
    reload() {
      this.items = [];

      getHome().then(response => {
        this.loading = false;
        if (response.data.status === "success") {
          this.items = response.data.data["api/slider"];
          // this.preitems = response.data.data["api/tops"];
        }
      });
    }
  },
  mounted() {
    this.reload();
  }
};
</script>

<style lang="scss">
@import "../sass/boots/custom_bootstrap";
.top-slider {
  height: 500px;
  &::after {
    content: "";
    width: 100%;
    height: 500px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.2);
  }
  @media (max-width: 425px) {
    height: 260px;
  }
  .carousel-caption {
    top: 30%;
    bottom: auto;
    padding: 0 100px;
    font-size: 2em;
    @media (max-width: 425px) {
      padding: 0;
      font-size: 1em;
    }
    h3 {
      font-size: 1.6em;
      text-shadow: 0 3px 3px rgba(0, 0, 0, 0.5);
    }
    p {
      text-transform: uppercase;
      font-weight: 300;
      font-size: 0.5em;
    }
  }
}
</style>
